import { PURCHASE_TYPE_AUTO_CHAIN, PURCHASE_TYPE_PROCESS_DOCUMENT } from './purchases'

export const HUMAN_ESCROW_TYPES = {
    [PURCHASE_TYPE_AUTO_CHAIN]: 'Title Chaining',
    [PURCHASE_TYPE_PROCESS_DOCUMENT]: 'Document Processing',
}

export const ESCROW_STATUS_PENDING = 'pending'
export const ESCROW_STATUS_FULFILLED = 'fulfilled'
export const ESCROW_STATUS_FAILED = 'failed'